export default __webpack_public_path__ + "static/media/logo_samatur_passagens.f9b77787.webp";